// extracted by css-extract-rspack-plugin
export default {"badges":"OverviewTitleBadges-module__badges","tag":"OverviewTitleBadges-module__tag","rating":"OverviewTitleBadges-module__rating"};